import type { SettingsBootstrap } from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createSettingsClient({ request }: { request: RequestFn }) {
  return {
    get: ({ projectId }: { projectId: string }) => {
      return request<SettingsBootstrap>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/settings`,
      });
    },
  };
}
